import React, { useState, useEffect } from 'react';
import { Zap, Droplets } from 'lucide-react';
import glovisLogo from './Glovis Logo_page-0001.jpg';
import deterImage from './deter.jpg';
import floorCleanerImage from './floor cleaner.png';
import toiletCleanerImage from './Toilet Cleaner.jpg';

export default function GlovisPage() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  // const [likedProducts, setLikedProducts] = useState(new Set());

  // const products = [
  //   {
  //     id: 'liquid-detergent',
  //     name: 'Liquid Detergent',
  //     category: 'DETERGENT LIQUIDS',
  //     description: 'Powerful yet gentle formula for superior cleaning',
  //     features: [
  //       { title: 'Safe Hands', description: 'Gentle formula safe for sensitive skin', color: 'blue', icon: Shield },
  //       { title: 'Color-Lock', description: 'Advanced technology preserves fabric colors', color: 'orange', icon: Heart },
  //       { title: 'Improved Polymer Technology', description: 'Enhanced cleaning performance', color: 'green', icon: Zap },
  //       { title: 'Superior Results', description: 'Excellent results in both bucket and machine wash', color: 'purple', icon: Award }
  //     ],
  //     sizes: [
  //       { size: '1L', type: 'Small Pack', color: 'blue', price: '₹120' },
  //       { size: '5L', type: 'Family Pack', color: 'orange', price: '₹550', popular: true }
  //     ],
  //     ingredients: [
  //       'Linear Alkyl Benzene',
  //       'Sulphonic Acid', 
  //       'Sodium Lauryl Ether Sulfate',
  //       'Acrylic Polymer',
  //       'Sodium Hydroxide',
  //       'Preservatives',
  //       'Sodium Chloride',
  //       'Perfume'
  //     ],
  //     gradient: 'from-blue-50 via-white to-orange-50/30',
  //     badgeColor: 'blue',
  //     primaryColor: 'blue',
  //     secondaryColor: 'orange',
  //     rating: 4.8,
  //     reviews: 1247,
  //     washes: '100+',
  //     loadType: 'Front & Top Load'
  //   },
  //   {
  //     id: 'floor-cleaner',
  //     name: 'Floor Cleaner',
  //     category: 'FLOOR CLEANERS',
  //     description: 'Multi-surface cleaning for spotless floors',
  //     features: [
  //       { title: 'Multi-Surface Safe', description: 'Safe for tiles, marble, granite, and wooden floors', color: 'orange', icon: Shield },
  //       { title: 'Anti-Bacterial Protection', description: 'Eliminates 99.9% of germs and bacteria', color: 'blue', icon: Zap },
  //       { title: 'Quick-Drying Formula', description: 'Fast-drying solution for immediate use', color: 'green', icon: Droplets },
  //       { title: 'Fresh Fragrance', description: 'Long-lasting pleasant scent', color: 'purple', icon: Heart }
  //     ],
  //     sizes: [
  //       { size: '500ml', type: 'Small Pack', color: 'orange', price: '₹85' },
  //       { size: '1L', type: 'Family Pack', color: 'blue', price: '₹150', popular: true }
  //     ],
  //     gradient: 'from-orange-50 via-white to-blue-50/30',
  //     badgeColor: 'orange',
  //     primaryColor: 'orange',
  //     secondaryColor: 'blue',
  //     rating: 4.6,
  //     reviews: 892
  //   },
  //   {
  //     id: 'toilet-cleaner',
  //     name: 'Toilet Cleaner',
  //     category: 'TOILET CLEANERS',
  //     description: 'High-strength disinfectant for deep cleaning and hygiene',
  //     features: [
  //       { title: 'Effective Stain Removal', description: 'Removes tough stains and limescale', color: 'purple', icon: Zap },
  //       { title: 'Germ-killing Power', description: 'Eliminates bacteria and germs', color: 'green', icon: Shield },
  //       { title: 'Fresh Fragrance', description: 'Long-lasting pleasant scent', color: 'pink', icon: Heart },
  //       { title: 'Safe for Surfaces', description: 'Gentle on ceramic and porcelain surfaces', color: 'blue', icon: Award }
  //     ],
  //     sizes: [
  //       { size: '250ml', type: 'Regular Pack', color: 'purple', price: '₹75' },
  //       { size: '500ml', type: 'Family Pack', color: 'pink', price: '₹140', popular: true }
  //     ],
  //     ingredients: [
  //       'Water',
  //       'Hydrochloric Acid',
  //       'Alkylamine Ethoxylate',
  //       'Perfume'
  //     ],
  //     gradient: 'from-purple-50 via-white to-pink-50/30',
  //     badgeColor: 'purple',
  //     primaryColor: 'purple',
  //     secondaryColor: 'pink',
  //     rating: 4.7,
  //     reviews: 634
  //   }
  // ];

  // const getColorClasses = (color) => {
  //   const colors = {
  //     orange: { bg: 'bg-orange-100', border: 'border-orange-200', text: 'text-orange-900', badge: 'bg-orange-100', badgeText: 'text-orange-800' },
  //     blue: { bg: 'bg-blue-100', border: 'border-blue-200', text: 'text-blue-900', badge: 'bg-blue-100', badgeText: 'text-blue-800' },
  //     green: { bg: 'bg-green-100', border: 'border-green-200', text: 'text-green-900', badge: 'bg-green-100', badgeText: 'text-green-800' },
  //     purple: { bg: 'bg-purple-100', border: 'border-purple-200', text: 'text-purple-900', badge: 'bg-purple-100', badgeText: 'text-purple-800' },
  //     pink: { bg: 'bg-pink-100', border: 'border-pink-200', text: 'text-pink-900', badge: 'bg-pink-100', badgeText: 'text-pink-800' }
  //   };
  //   return colors[color] || colors.blue;
  // };

  // const toggleLike = (productId) => {
  //   const newLikedProducts = new Set(likedProducts);
  //   if (newLikedProducts.has(productId)) {
  //     newLikedProducts.delete(productId);
  //   } else {
  //     newLikedProducts.add(productId);
  //   }
  //   setLikedProducts(newLikedProducts);
  // };

  // const renderStars = (rating) => {
  //   return Array.from({ length: 5 }, (_, i) => (
  //     <Star
  //       key={i}
  //       className={`w-3 h-3 ${i < Math.floor(rating) ? 'text-yellow-400 fill-current' : 'text-gray-300'}`}
  //     />
  //   ));
  // };

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white py-12">
      {/* Hero Section */}
      <section className="relative py-12 bg-gradient-to-br from-blue-50 via-white to-orange-50/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center justify-center text-center space-y-8">
            
            {/* Main heading */}
            <div className="space-y-4 py-12">
              <h1 className="text-5xl sm:text-6xl font-bold text-gray-900 leading-tight">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-orange-600">GLOVIS</span>
              </h1>
            </div>

            {/* Glovis Logo */}
            <div className="relative w-full max-w-md">
              <div className="bg-white rounded-2xl p-8">
                <img 
                  src={glovisLogo} 
                  alt="Glovis Logo" 
                  className="w-full h-full object-contain"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="hidden items-center justify-center h-full w-full">
                  <span className="text-xl font-bold text-gray-700 text-center">Glovis Logo</span>
                </div>
              </div>
            </div>

            {/* Product Categories */}
            <div className="text-center">
              <div className="flex flex-wrap justify-center gap-4">
                <div className="px-4 py-2 bg-blue-50 rounded-full border border-blue-200">
                  <span className="text-sm font-semibold text-blue-700">DETERGENT LIQUID</span>
                </div>
                <div className="px-4 py-2 bg-orange-50 rounded-full border border-orange-200">
                  <span className="text-sm font-semibold text-orange-700">FLOOR CLEANER</span>
                </div>
                <div className="px-4 py-2 bg-purple-50 rounded-full border border-purple-200">
                  <span className="text-sm font-semibold text-purple-700">TOILET CLEANER</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-24 bg-gradient-to-br from-gray-50 via-white to-blue-50/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-left mb-20">
            <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-blue-100 to-orange-100 px-4 py-2 rounded-full mb-6">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <span className="text-sm font-semibold text-blue-700">Premium Collection</span>
            </div>
            <h2 className="text-5xl sm:text-6xl font-bold text-gray-900 mb-8">
              Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-orange-600">Products</span>
            </h2>
            <div className="w-32 h-1 bg-gradient-to-r from-blue-500 to-orange-500 rounded-full mb-10"></div>
            <p className="text-xl text-gray-600 max-w-4xl leading-relaxed">
              Discover the advanced technology and premium ingredients that make Glovis Detergent the perfect choice for your laundry needs
            </p>
          </div>

          {/* Product Cards */}
          <div className="space-y-24">
            
            {/* Liquid Detergent Card */}
            <div className="relative">
              <div className="bg-white rounded-3xl border border-gray-200 overflow-hidden">
                <div className="grid xl:grid-cols-2 min-h-[600px]">
                  
                  {/* Left Side - Content */}
                  <div className="p-12 flex flex-col justify-center">
                    <div className="space-y-8">
                      {/* Product Badge */}
                     
                      
                      {/* Product Title */}
                      <div>
                        <h3 className="text-4xl font-bold text-gray-900 mb-4"> Detergent</h3>
                        <p className="text-lg text-gray-600 leading-relaxed">
                          Our Liquid Detergent is a powerful yet gentle formula designed to remove tough stains while keeping fabrics soft and fresh. With advanced stain-fighting technology, it works effectively in both hot and cold water, leaving clothes bright, clean, and long-lasting. Eco-friendly and safe for all fabrics, it ensures a refreshing fragrance with every wash.
                        </p>
                      </div>

                      {/* Sizes Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="text-center p-4 bg-gradient-to-br from-blue-50 to-orange-50 rounded-xl">
                          <span className="text-2xl font-bold text-blue-600 block">5L</span>
                          <span className="text-sm text-gray-500">Family Pack</span>
                        </div>
                        <div className="text-center p-4 bg-gradient-to-br from-orange-50 to-blue-50 rounded-xl">
                          <span className="text-2xl font-bold text-orange-600 block">1L</span>
                          <span className="text-sm text-gray-500">Regular Pack</span>
                        </div>
                      </div>

                      {/* Features Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">SafeHands</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Color-Lock</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Improved Polymer Technology</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Excellent Result in Both Bucket and Machine Wash</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Superior Powerful stain removal formula</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-pink-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Gentle on hands & fabrics</span>
                        </div>
                      </div>

                      {/* Ingredients */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Premium Ingredients</h4>
                        <p className="text-sm text-gray-600">
                          Linear Alkyl Benzene, Sulphonic Acid, Sodium Lauryl Ether Sulfate, Acrylic Polymer, Sodium Hydroxide, Preservatives, Sodium Chloride, Perfume
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Right Side - Image */}
                  <div className="bg-gradient-to-br from-blue-50 via-white to-orange-50 flex items-center justify-center p-12">
                    <div className="relative w-full max-w-md">
                      <div className="bg-white rounded-2xl p-8 ">
                        <img 
                          src={deterImage} 
                          alt="Glovis Liquid Detergent" 
                          className="w-full h-full object-contain"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Floor Cleaner Card */}
            <div className="relative">
              <div className="bg-white rounded-3xl border border-gray-200 overflow-hidden">
                <div className="grid xl:grid-cols-2 min-h-[600px]">
                  
                  {/* Left Side - Image */}
                  <div className="bg-gradient-to-br from-orange-50 via-white to-green-50 flex items-center justify-center p-12">
                    <div className="relative w-full max-w-md">
                      <div className=" rounded-2xl p-8 ">
                        <img 
                          src={floorCleanerImage} 
                          alt="Glovis Floor Cleaner" 
                          className="w-full h-full object-contain"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Right Side - Content */}
                  <div className="p-12 flex flex-col justify-center">
                    <div className="space-y-8">
                      {/* Product Badge */}
                      {/* <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-orange-100 to-green-100 px-4 py-2 rounded-full">
                        <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                        <span className="text-sm font-semibold text-orange-700">FLOOR CLEANERS</span>
                      </div> */}
                      
                      {/* Product Title */}
                      <div>
                        <h3 className="text-4xl font-bold text-gray-900 mb-4">Floor Cleaner</h3>
                        <p className="text-lg text-gray-600 leading-relaxed">
                         Our Floor Cleaner is a powerful disinfectant that removes dirt, stains, and germs,
leaving floors spotless and fresh. Its fast-drying, non-sticky formula works on all
surfaces, providing a safe, hygienic environment for homes and businesses.
Available in three refreshing fragrances, it keeps your space clean and pleasantly
scented all day long.
                        </p>
                      </div>

                      {/* Sizes Grid */}
                      <div className="grid grid-cols-1 gap-4">
                        <div className="text-center p-4 bg-gradient-to-br from-orange-50 to-green-50 rounded-xl">
                          <span className="text-2xl font-bold text-orange-600 block">500ml</span>
                          <span className="text-sm text-gray-500">Triple Germ Action</span>
                        </div>
                      </div>

                      {/* Fragrances Grid */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Available Fragrances</h4>
                        <div className="grid grid-cols-3 gap-3">
                          <div className="text-center p-3 bg-gradient-to-br from-pink-50 to-rose-50 rounded-lg border border-pink-200">
                            <span className="text-sm font-semibold text-pink-700 block">Mystic Rose</span>
                         
                          </div>
                          <div className="text-center p-3 bg-gradient-to-br from-orange-50 to-yellow-50 rounded-lg border border-orange-200">
                            <span className="text-sm font-semibold text-orange-700 block">Sparkling Citrus</span>
                            
                          </div>
                          <div className="text-center p-3 bg-gradient-to-br from-green-50 to-lime-50 rounded-lg border border-green-200">
                            <span className="text-sm font-semibold text-green-700 block">Lemongrass</span>
                     
                          </div>
                        </div>
                      </div>

                      {/* Features Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Triple germ action</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Eco Safe</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Long Lasting Fragrance</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">100% Removal of Stains</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Quick Drying</span>
                        </div>
                      </div>

                      {/* Ingredients */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Premium Ingredients</h4>
                        <p className="text-sm text-gray-600">
                          Alphox200, Colour, Perfume
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Toilet Cleaner Card */}
            <div className="relative">
              <div className="bg-white rounded-3xl border border-gray-200 overflow-hidden">
                <div className="grid xl:grid-cols-2 min-h-[600px]">
                  
                  {/* Left Side - Content */}
                  <div className="p-12 flex flex-col justify-center">
                    <div className="space-y-8">
                      {/* Product Badge */}
                      {/* <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-purple-100 to-pink-100 px-4 py-2 rounded-full">
                        <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                        <span className="text-sm font-semibold text-purple-700">TOILET CLEANERS</span>
                      </div> */}
                      
                      {/* Product Title */}
                      <div>
                        <h3 className="text-4xl font-bold text-gray-900 mb-4">Toilet Cleaner</h3>
                        <p className="text-lg text-gray-600 leading-relaxed">
Our Toilet Cleaner is a high-strength
disinfectant that removes tough stains,
limescale, and bacteria, ensuring a
deep-cleaned, germ-free toilet. Its thick
formula clings to surfaces, providing
long-lasting protection and a fresh
fragrance. Safe for ceramic and porcelain, it
keeps toilets sparkling clean and hygienic
with every use .

                        </p>
                      </div>

                      {/* Sizes Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="text-center p-4 bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl">
                          <span className="text-2xl font-bold text-purple-600 block">250ml</span>
                          <span className="text-sm text-gray-500">Regular Pack</span>
                        </div>
                        <div className="text-center p-4 bg-gradient-to-br from-pink-50 to-purple-50 rounded-xl">
                          <span className="text-2xl font-bold text-pink-600 block">500ml</span>
                          <span className="text-sm text-gray-500">Family Pack</span>
                        </div>
                      </div>

                      {/* Features Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Effective stain removal</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Germ-killing power</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-pink-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Fresh fragrance</span>
                        </div>
                      </div>

                      {/* Ingredients */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Premium Ingredients</h4>
                        <p className="text-sm text-gray-600">
                          Water, Hydrochloric Acid, Alkylamine Ethoxylate, Perfume
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Right Side - Image */}
                  <div className="bg-gradient-to-br from-purple-50 via-white to-pink-50 flex items-center justify-center p-12">
                    <div className="relative w-full max-w-md">
                      <div className="bg-white rounded-2xl p-8 
                      ">
                        <img 
                          src={toiletCleanerImage} 
                          alt="Glovis Toilet Cleaner" 
                          className="w-full h-full object-contain"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Modal */}
      {selectedProduct && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-lg w-full max-h-[80vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-lg font-bold text-gray-900">{selectedProduct.name}</h3>
                <button 
                  onClick={() => setSelectedProduct(null)}
                  className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
                >
                  <span className="text-xl">×</span>
                </button>
              </div>
              
              <div className="space-y-4">
                <p className="text-sm text-gray-600">{selectedProduct.longDescription}</p>
                
                {selectedProduct.ingredients && (
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2 text-sm">Ingredients:</h4>
                    <div className="grid grid-cols-2 gap-2">
                      {selectedProduct.ingredients.map((ingredient, idx) => (
                        <div key={idx} className="text-xs text-gray-600 bg-gray-50 px-2 py-1 rounded">
                          {ingredient}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                
                {selectedProduct.washes && (
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-2">
                      <Droplets className="w-4 h-4 text-blue-600" />
                      <span className="text-xs font-medium">{selectedProduct.washes} washes</span>
                    </div>
                    {selectedProduct.loadType && (
                      <div className="flex items-center space-x-2">
                        <Zap className="w-4 h-4 text-orange-600" />
                        <span className="text-xs font-medium">{selectedProduct.loadType}</span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
